import { useQuery } from "@tanstack/react-query";
import { getUsersSearchHunters, type Region } from "Infrastructure/Api/Api";
import { MS_TIME } from "Utils/TimeUtils";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const HUNTER_SEARCH_QUERY_KEY = "HUNTER_SEARCH";

export const hunterSearchKeys = {
  all: [HUNTER_SEARCH_QUERY_KEY],
  byQuery: (
    query: string,
    region?: Region | null,
    isHunterWithoutLicenseIncluded = false,
  ) => [...hunterSearchKeys.all, query, region, isHunterWithoutLicenseIncluded],
};

export const useHunterSearchQuery = (
  query: string,
  enabled = true,
  region?: Region | null,
  isHunterWithoutLicenseIncluded = false,
) =>
  useQuery({
    queryKey: hunterSearchKeys.byQuery(
      query,
      region,
      isHunterWithoutLicenseIncluded,
    ),
    queryFn: processResponseWithApiProblemDetails(() =>
      // Region scopes the results to licenses of that market — commission can only be
      // shared within one market.
      getUsersSearchHunters(
        query,
        region ?? undefined,
        isHunterWithoutLicenseIncluded,
      ),
    ),
    enabled: enabled && query.length >= 2,
    refetchOnWindowFocus: false,
    staleTime: 5 * MS_TIME.minute,
  });
